/* @flow */
import React from 'react';
import cx from 'classnames';
import './styles/BoxHeader.scss';

class BoxHeader extends React.Component {
  static propTypes = {
    title: React.PropTypes.node,
    subtext: React.PropTypes.node,
    aux: React.PropTypes.node,
  };

  renderTitle() {
    const { title } = this.props;
    if (!title) {
      return null;
    }

    // TODO: shouldn't reference `.Box-*` styles
    if (this.props.aux) {
      return (
        <div className="BoxHeader-inner">
          <h2 className="Box-title">
            {title}
          </h2>
          <div>
            {this.props.aux}
          </div>
        </div>
      );
    }

    return <h2 className="BoxHeader-title">{title}</h2>;
  }

  renderSubtext() {
    if (this.props.subtext) {
      return <h3 className="BoxHeader-subtext">{this.props.subtext}</h3>;
    } else {
      return null;
    }
  }

  render() {
    return (
      <header className={cx('BoxHeader', this.props.className)}>
        {this.renderTitle()}
        {this.renderSubtext()}
        {this.props.children}
      </header>
    );
  }
}

export default BoxHeader;



// WEBPACK FOOTER //
// ./src/components/BoxHeader.jsx